import React from "react";
import { Line as KonvaLine } from "react-konva";
const Line = ({ shape, shapeProps }) => {
	return (
		<KonvaLine
			{...shapeProps}
			points={shape.points}
			stroke="black"
			strokeWidth={2}
			key={shape.id}
		/>
	);
};

export default Line;
